import { gql } from 'urql';

export const GET_USER_ACCOUNT = gql`
  query GetUserAccount {
    identity {
      user {
        id
        fullname: fullName
        email
        isAdmin
        userAccounts {
          id
          account {
            name
          }
        }
        avatarUrl
      }
      account {
        id
        name
        company: name
        createdAt
        flowsShownLimit
        isTrial
        isTrialExpired
        trialLengthDays
        stripePlanId
        aiAllowEndUserData
      }
    }
    trialStatus {
      expirationDate
      isExpired
      isWebInstalled
      isMobileInstalled
      lengthDays
      createdAt
    }
  }
`;

export const ASSISTANT_SESSIONS = gql`
  query AssistantSessions(
    $filter: AssistantSessionFilter
    $page: Page
    $sort: [AssistantSessionSortOrder!]
  ) {
    assistantSessions(filter: $filter, page: $page, sort: $sort) {
      sessions {
        id
        createdAt
        title
        summary
      }
    }
  }
`;

export const GET_ASSISTANT_SESSION_MESSAGES = gql`
  query GetAssistantSessionMessages($id: ID!) {
    assistantSession(id: $id) {
      messages {
        message
      }
    }
  }
`;

export const DELETE_ASSISTANT_SESSION = gql`
  mutation DeleteAssistantSession($id: String!) {
    deleteAssistantSession(id: $id) {
      success
    }
  }
`;

export const AGENT_MEMORY = gql`
  query AgentMemory {
    agentMemory {
      id
      ownerId
      content
      updatedAt
    }
  }
`;

export const GET_CONTENTS = gql`
  query GetContents(
    $filter: ContentFilter
    $pageInfo: PageInput
    $sort: [ContentSortOrder!]
  ) {
    contents(filter: $filter, pageInfo: $pageInfo, sort: $sort) {
      content {
        id
        name
        type
        updatedAt
        state
        published
        publishedAndDirty
        folder {
          id
          name
        }
      }
      pageInfo {
        total
        offset
        limit
      }
    }
  }
`;
